export default __webpack_public_path__ + "static/AvenirLTStd-Medium-199e87ddfd0cf3bf7130efef3251de93.woff2";